module.exports = __webpack_public_path__ + "img/ES00.24113e59.svg";